import React from 'react';
import './ContactModal.css';

const ContactModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handleEmailClick = (email) => {
    window.location.href = `mailto:${email}`;
  };

  return (
    <div className="contact-modal-overlay" onClick={handleBackdropClick}>
      <div className="contact-modal-content">
        <button className="contact-modal-close" onClick={onClose}>
          ×
        </button>
        <h2 className="contact-modal-title">CONTACT US</h2>
        <div className="contact-info-container">
          <div className="contact-item">
            <h3 className="contact-category">MANAGEMENT QUERIES</h3>
            <a 
              href="mailto:MANAGEMENT@THEHILLSFESTIVAL.IN" 
              className="contact-email"
              onClick={(e) => {
                e.preventDefault();
                handleEmailClick('MANAGEMENT@THEHILLSFESTIVAL.IN');
              }}
            >
              MANAGEMENT@THEHILLSFESTIVAL.IN
            </a>
          </div>
          <div className="contact-item">
            <h3 className="contact-category">ARTIST QUERIES</h3>
            <a 
              href="mailto:ARTIST@THEHILLSFESTIVAL.IN" 
              className="contact-email"
              onClick={(e) => {
                e.preventDefault();
                handleEmailClick('ARTIST@THEHILLSFESTIVAL.IN');
              }}
            >
              ARTIST@THEHILLSFESTIVAL.IN
            </a>
          </div>
          <div className="contact-item">
            <h3 className="contact-category">HOSPITALITY QUERIES</h3>
            <a 
              href="mailto:HOSPITALITY@THEHILLSFESTIVAL.IN" 
              className="contact-email"
              onClick={(e) => {
                e.preventDefault();
                handleEmailClick('HOSPITALITY@THEHILLSFESTIVAL.IN');
              }}
            >
              HOSPITALITY@THEHILLSFESTIVAL.IN
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactModal;
